export function getSavedPage(key) {
  if (!key) return 1;
  const raw = sessionStorage.getItem(`pagination:${key}`);
  const page = parseInt(raw, 10);
  return Number.isFinite(page) && page > 0 ? page : 1;
}

export function setSavedPage(key, page) {
  if (!key) return;
  const pageNumber = parseInt(page, 10);
  if (!Number.isFinite(pageNumber) || pageNumber <= 0) return;
  sessionStorage.setItem(`pagination:${key}`, String(pageNumber));
}
